import { AppUser } from "@eventr/common";

/**
 * The user a guest account is following, if any. Guest accounts have no itinerary of their
 * own and browse as the user they were set up to follow.
 */
export function followedUserId(user: AppUser | undefined): number | undefined {
  if (!user?.roles?.includes("guest")) return undefined;
  return typeof user.followUserId === "number" ? user.followUserId : undefined;
}
